import { useNavigate, useNavigation } from "react-router-dom";
import Link from "./Link.js";
import styled from "styled-components";
import { MoonLoader } from "react-spinners";
import goTo from "../../controllers/goTo.js";
import { Button, Tooltip } from "@mui/material";
import { useContext } from "react";
import Context from "../../Context.js";

const Text = styled.div`
  /* text-transform: lowercase; */
  font-weight: 900;
  display: flex;
  color: var(--element);

  font-family: var(--headingFont);

  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 13px;

  @media (max-width: 900px) {
    font-size: 11px;
  }
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--element);
`;

export default function CustomButton({
  children,
  icon,
  onClick,
  href,
  style,
  variant,
  isLoading,
  isActive,
  onActiveStyle,
  disabled,
  onlyDesktop,
  customVariant,
  textStyle,
  iconStyle,
}) {
  const { isMobile } = useContext(Context);

  if (onlyDesktop) {
    if (isMobile) return null;
  }
  if (href && !onClick) {
    onClick = () => {
      goTo(href)();
    };
  }

  if (!variant && !customVariant) {
    customVariant = "slightlyContained";
  }

  if (!style) style = {};

  if (disabled) {
    style = { ...style, opacity: 0.5, pointerEvents: "none" };
  }

  if (isActive && onActiveStyle) {
    style = { ...style, ...onActiveStyle };
  }

  if (isLoading) icon = <MoonLoader size="20px" color="var(--color)" />;

  if (icon) icon = <Icon style={iconStyle}>{icon}</Icon>;

  let additionalStyle = {};
  if (!children) {
    if (icon) {
      children = icon;
      icon = null;
      additionalStyle = { height: "60px", width: "60px", padding: 0 };
    }
  } else {
    children = <Text style={textStyle}>{children}</Text>;
  }

  if (customVariant) {
    if (customVariant == "slightlyContained") {
      additionalStyle = {
        ...additionalStyle,
        background: `var(--surface)`,
        border: `1px solid var(--border)`,
      };
    }
  }

  return (
    <Button
      onClick={theClick}
      style={{
        padding: "10px 20px",
        gap: "10px",
        borderRadius: "50px",
        boxShadow: "unset",
        ...additionalStyle,
        ...style,
      }}
      variant={variant}
      startIcon={icon}
    >
      {children}
    </Button>
  );

  function theClick(e) {
    e.preventDefault();
    if (onClick) onClick(e);
  }
}
